(function() {
	/*
	 * Ad Blocker Usage
	 * Requires the following libs:
	 * globalService
     *
     * Usage:
     * <sug-abu></sug-abu>
	 */
	SUGApp.directive('sugAbu', ['$timeout','$modal','globalService','SUGUtilities', function ($timeout,$modal,globalService,util) {
		return {
            restrict: 'E',
			scope: {},
			link: function(scope, element, attrs) {

                scope.showModal = false;

				// this runs first
				function init(){
                    detectAdBlockUsage();
				}

                /**
                 * Creates an empty div using a class that is known for being blocked by ad blockers.
                 * If the div's offsetHeight is 0, then an ad blocker is enabled and it logs the usage record.
                 */
                function detectAdBlockUsage(){
                    var adBlockerDiv = document.createElement('div');
                    adBlockerDiv.textContent = '\u00a0'; //unicode character adds a nonbreaking space to our element
                    adBlockerDiv.className = 'ads ad adsbox doubleclick ad-placement carbon-ads adholder2';
					adBlockerDiv.style.color = "transparent"; //ensures placeholder string is not visible.
                    element.append(adBlockerDiv);

                    $timeout( function(){
                        if( adBlockerDiv.offsetHeight === 0 ){
                            logAdBlockerUsage();
                        }else{
                            // lets try to load the sugabu-ads file
                            var adBlockerScript = document.createElement('script');
                            adBlockerScript.src = '/js/sugabu-ads.js';
                            element.append(adBlockerScript);
                            if( !window.sugabuAdsLoaded ){
                                logAdBlockerUsage();
                            }
                            angular.element(adBlockerScript).remove();
                        }
                        angular.element(adBlockerDiv).remove();
                    });


                }

                /**
                 * Calls c.logAdBlockerUsage API endpoint to log ad blocker usage, and launches the modal message to user if the reponse tells us to do so.
                 */
                function logAdBlockerUsage(){

                    globalService.logAdBlockerUsage({}).then( function( response ){
                        //validate the response
                        if( util.ajaxResultInvalid( response.data ) ){
                            // silent error
                        } else {
                            //response was valid
                            var r = util.lowerCaseKeys( response.data );
                            if( r.success ){
                                if( r.data.showmodal ){
                                    // launch message modal
                                    $modal.open({
                                        templateUrl: '/view/templates/ngtemplates/sug-abu-modal.html',
                                        controller: adBlockerUsageModalCtrl
                                    });
                                }
                            }
                        }
                    });

                }

                /**
                 * Controller to handle the ad blocker message modal.
                 */
                var adBlockerUsageModalCtrl = ['$scope','$modalInstance', function($scope, $modalInstance ) {
                    $scope.close = function () {
                        $modalInstance.close(true);
                    };
                    $scope.dismiss = function () {
                        $modalInstance.dismiss(false);
                    };
                }];

                // fire init
				init();
            }
        };
    }]);

}());
